import { useTheme } from '@mui/material';

import Button from '@webclient/components/generate-icon/components/icon/button';
import Animation from '@webclient/components/generate-icon/components/icon/generator/animation';
import {
  StyledGradientBox,
  StyledStack,
} from '@webclient/components/generate-icon/components/icon/generator/styles';

import SmartStarIcon from '~icons/knowz-iconify/smart-star';

type Props = {
  handleSetSelectedIcon: (icon: string) => void;
  iconGenerationStatus: string;
  generatedIcons: string[] | null;
  selectedIcon: string;
};

const ICON_PLACEHOLDER_COUNT = import.meta.env.DEV ? 2 : 4;

export default function Generator({
  generatedIcons,
  handleSetSelectedIcon,
  iconGenerationStatus,
  selectedIcon,
}: Props) {
  const theme = useTheme();
  const emptyIcons =
    (generatedIcons == null ||
      (Array.isArray(generatedIcons) && generatedIcons.length === 0)) &&
    iconGenerationStatus === 'idle';
  if (emptyIcons || iconGenerationStatus === 'failed') {
    return Array.from({ length: ICON_PLACEHOLDER_COUNT }, (_, index) => (
      <StyledGradientBox key={index}>
        <StyledStack>
          <SmartStarIcon color={theme.palette.foreground.quaternary} />
        </StyledStack>
      </StyledGradientBox>
    ));
  }

  if (iconGenerationStatus === 'pending') {
    return Array.from({ length: ICON_PLACEHOLDER_COUNT }, (_, index) => (
      <Animation
        key={index}
        loadingStatus={iconGenerationStatus}
      />
    ));
  }

  return generatedIcons?.map((icon, index) => (
    <Button
      key={index}
      icon={icon}
      handleSetSelectedIcon={handleSetSelectedIcon}
      selectedIcon={selectedIcon}
    />
  ));
}
